import { __decorate, __metadata } from "tslib";
// NPM
import { StateSaveModel } from "@/store/models/state/stateSaveDTO";
import { Component, Prop, Mixins } from "vue-property-decorator";
import BaseMixer from "../../BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
// SYSTEMONE
let StateUpsertComponent = /** @class */ (() => {
    var _a;
    let StateUpsertComponent = class StateUpsertComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.isLoading = false;
        }
        showModal() {
            this.$bvModal.show("state-modal");
        }
        saveState() {
            this.validate("stateObserver").then((res) => {
                if (res) {
                    this.isLoading = true;
                    this.$emit("saveState", this.stateDetail);
                }
            });
        }
        hideModal() {
            this.$bvModal.hide("state-modal");
        }
        stopLoading() {
            this.isLoading = false;
            this.hideModal();
        }
        loading() {
            this.isLoading = false;
        }
        cancelState() {
            this.$emit("cancel");
            this.hideModal();
        }
        created() { }
        destroyed() { }
    };
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], StateUpsertComponent.prototype, "title", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof StateSaveModel !== "undefined" && StateSaveModel) === "function" ? _a : Object)
    ], StateUpsertComponent.prototype, "stateDetail", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", String)
    ], StateUpsertComponent.prototype, "buttonName", void 0);
    StateUpsertComponent = __decorate([
        Component({
            name: "StateUpsertComponent",
            components: {
                SectionLoader,
            },
        })
    ], StateUpsertComponent);
    return StateUpsertComponent;
})();
export default StateUpsertComponent;
